import React, { Component, Fragment } from "react";
import { addCameraRoi, getCameraRoiById, updateCameraRoi } from "./_redux";
import { successToast, warningToast } from "../../../../utils/ToastMessage";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import CustomizedButtons from "../../../../utils/SuperAdmin/CustomizedButtons";
import CustomizedSwitch from "../../../../utils/SuperAdmin/CustomizedSwitch";
class RegionPlot1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRegionPlotModal: props.viewRegionPlotModal,
      isDown: false,
      previousPointX: "",
      previousPointY: "",
      coordinates: [],
      roi_coordinates: [],
      updatedCoordinates: [],
      imagePath: props.imagePath,
      roi_type: props.cameraParam.roi_type || 'RECTANGLE',
      regionContainsPlot: false,
      blockUI: false,
      disableSaveBtn: true,
      disableUpdateBtn: true,
      showAllploted: false,
      checkboxShowAllROI: false,
      crop: { unit: "px" },
      polygonClosed: false,
      displayWidth: 640,
      displayHeight: 640
    };
    this.polygonCanvasRef = React.createRef();
  }

  componentDidMount() {
    const canvas = document.createElement("canvas");
    this.setState({
      canvas: canvas
    });
    const context = canvas.getContext("2d");
    const image = new Image();

    image.onload = () => {
      context.drawImage(image, 0, 0, 640, 640);
    };
    image.src = this.state.imagePath;
    this.getCameraROIById(this.props.cameraParam.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      viewRegionPlotModal: nextProps.viewRegionPlotModal
    });
  }

  // Polygon drawing helpers
  setPolygonCanvas = el => {
    this.polygonCanvasRef.current = el;
    if (el && this.state.roi_type === "POLYGON") {
      this.drawPolygonBase();
    }
  };

  drawPolygonBase = () => {
    const canvas = this.polygonCanvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = () => {
      // Preserve aspect ratio with a fixed display width
      const targetW = 640;
      const targetH = Math.round((img.naturalHeight * targetW) / img.naturalWidth);
      canvas.width = targetW;
      canvas.height = targetH;
      this.setState({ displayWidth: targetW, displayHeight: targetH });
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, targetW, targetH);
      this.redrawWorkingPolygon();
    };
    img.src = this.state.imagePath;
  };

  redrawWorkingPolygon = () => {
    const canvas = this.polygonCanvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const pts = this.state.coordinates;
    if (!pts || pts.length === 0) return;
    ctx.strokeStyle = "#00a5ff";
    ctx.fillStyle = "rgba(0,165,255,0.2)";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(pts[0][0], pts[0][1]);
    for (let i = 1; i < pts.length; i++) {
      ctx.lineTo(pts[i][0], pts[i][1]);
    }
    if (this.state.polygonClosed) {
      ctx.closePath();
      ctx.fill();
    }
    ctx.stroke();
    // draw first point marker to aid closing
    if (pts.length > 0) {
      ctx.beginPath();
      ctx.fillStyle = "#00a5ff";
      ctx.arc(pts[0][0], pts[0][1], 4, 0, Math.PI * 2);
      ctx.fill();
    }
  };

  handleCanvasClick = e => {
    if (this.state.roi_type !== "POLYGON") return;
    const canvas = this.polygonCanvasRef.current;
    if (!canvas) return;
    const rect = canvas.getBoundingClientRect();
    // Map from CSS pixels to canvas coordinates
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const x = Math.round((e.clientX - rect.left) * scaleX);
    const y = Math.round((e.clientY - rect.top) * scaleY);

    let pts = [...this.state.coordinates];
    if (pts.length > 2) {
      const dx = x - pts[0][0];
      const dy = y - pts[0][1];
      const dist2 = dx * dx + dy * dy;
      if (dist2 < 100) {
        // close POLYGON
        this.setState(
          { coordinates: pts, polygonClosed: true, disableSaveBtn: false, disableUpdateBtn: false },
          () => this.drawPolygonBase()
        );
        return;
      }
    }
    pts.push([x, y]);
    this.setState({ coordinates: pts, polygonClosed: false, disableSaveBtn: false, disableUpdateBtn: false }, () => {
      this.drawPolygonBase();
    });
  };

  undoLastPoint = () => {
    if (this.state.roi_type !== "POLYGON") return;
    let pts = [...this.state.coordinates];
    pts.pop();
    this.setState({ coordinates: pts, polygonClosed: false }, () => this.drawPolygonBase());
  };

  clearPolygon = () => {
    if (this.state.roi_type !== "POLYGON") return;
    this.setState({ coordinates: [], polygonClosed: false }, () => this.drawPolygonBase());
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    // If polygon mode is active and coordinates or type changed, redraw
    if (
      this.state.roi_type === 'POLYGON' &&
      this.polygonCanvasRef.current &&
      (prevState.roi_type !== this.state.roi_type || prevState.coordinates !== this.state.coordinates)
    ) {
      this.drawPolygonBase();
    }
  }

  getCameraROIById = cameraId => {
    this.setState({
      blockUI: true
    });
    setTimeout(() => {
      try {
        getCameraRoiById(cameraId).then(response => {
          let responseObj = response.data;

          if (responseObj.length > 0) {
            this.setState(
              {
                regionContainsPlot: true,
                imageHasPlotPoint: true,
                roiCoordinatesObjFromAPI: responseObj
              },
              () => {
                // setTimeout(()=> {
                let btn = document.getElementById("0button");
                if (btn) {
                  btn.click();
                }

                // },500)
              }
            );

            let obj = responseObj[responseObj.length - 1];
            if (obj.coordinates) {
              let cor = JSON.parse(obj.coordinates);
              // Determine saved ROI type from multiple possible locations
              let savedType = obj.roi_type;
              if (!savedType && obj.camera_settings && obj.camera_settings.roi_type !== undefined) {
                // Some APIs send boolean: true => POLYGON, false => RECTANGLE
                savedType = obj.camera_settings.roi_type === true ? 'POLYGON' : 'RECTANGLE';
              }
              const roiType = savedType ? savedType : this.state.roi_type;
              if (savedType && savedType !== this.state.roi_type) {
                this.setState({ roi_type: savedType });
              }
              if (roiType === 'POLYGON') {
                this.setState({
                  coordinates: cor,
                  polygonClosed: true,
                  blockUI: false,
                  coordinateId: obj.id
                }, () => {
                  if (this.polygonCanvasRef.current) {
                    this.drawPolygonBase();
                  }
                });
              } else {
                // If coordinates contain 4+ points, assume first 3 define RECTANGLE
                let initalPoint = cor[0];
                let secondPoint = cor[1];
                let thirdPoint = cor[2];

                let x = initalPoint[0];
                let y = initalPoint[1];
                let w = Math.abs(secondPoint[0] - initalPoint[0]);
                let h = Math.abs(thirdPoint[1] - secondPoint[1]);
                let crop = this.state.crop;
                crop.x = x;
                crop.y = y;
                crop.width = w;
                crop.height = h;
                this.setState({
                  crop: crop,
                  blockUI: false,
                  coordinateId: obj.id
                });
                const canvas = this.state.canvas;
                let ctx = canvas.getContext("2d");
                ctx.beginPath();
              }
            } else {
              this.setState({
                crop: [],
                regionContainsPlot: false,
                imageHasPlotPoint: false,
                blockUI: false
              });
            }
          } else {
            this.setState({
              regionContainsPlot: false,
              imageHasPlotPoint: false,
              blockUI: false
            });
          }
        });
      } catch (e) {
        this.setState({
          blockUI: false
        });
        console.log("error.detail",e)
      }
    }, 5000);
  };

  cropUpdateImage = () => {
    let coordinate = this.state.coordinates;
    if (coordinate.length > 0) {
      this.setState({
        blockUI: true
      });
      setTimeout(() => {
        let cameraCor = coordinate;
        let cameraParam = this.props.cameraParam;
        let param = {
          coordinates: JSON.stringify(cameraCor),
          camera_id: cameraParam.id,
          status: false,
          roi_type: this.state.roi_type,
          id: this.state.coordinateId
        };
        updateCameraRoi(param).then(response => {
          if (response && response.isSuccess) {
            this.setState(
              {
                imageHasPlotPoint: true,
                blockUI: false,
                disableSaveBtn: true,
                disableUpdateBtn: true
              },
              () => {
                successToast("Co-ordinates saved ");
              }
            );
          }
        });
      }, 500);
    } else {
      warningToast("Please select region");
    }
  };
  setRoiType = type => {
    this.setState({
      roi_type: type,
      coordinates: [],
      crop: { unit: "px" },
      polygonClosed: false
    }, () => {
      if (type === "POLYGON" && this.polygonCanvasRef.current) {
        this.drawPolygonBase();
      }
    });
  };
  handleCrop = crop => {
    this.setState({
      crop: crop
    });
  };
  onImageLoaded = image => {
    this.imageRef = image;
    // Compute display size preserving aspect ratio (target width 640)
    const naturalW = 640;
    const naturalH = image.naturalHeight || 640;
    const targetW = 640;
    const targetH = Math.round((naturalH * targetW) / naturalW);
    if (this.state.displayWidth !== targetW || this.state.displayHeight !== targetH) {
      this.setState({ displayWidth: targetW, displayHeight: targetH });
    }
    // Ensure a visible default crop in RECTANGLE mode when none exists
    if (
      (this.state.roi_type === 'RECTANGLE') &&
      (!this.state.crop || this.state.crop.width === undefined || this.state.crop.height === undefined)
    ) {
      const crop = { unit: 'px', x: 0, y: 0, width: targetW, height: targetH };
      this.setState({ crop });
    }
  };

  onCropComplete = crop => {
    let coordinate = [];
    let x1 = crop.x;
    let y1 = crop.y;
    let w = crop.width;
    let h = crop.height;

    let z1 = [x1, y1];
    let z2 = [x1 + w, y1];
    let z3 = [x1 + w, y1 + h];
    let z4 = [x1, y1 + h];
    coordinate = [z1, z2, z3, z4];

    this.setState({
      coordinates: coordinate,
      disableUpdateBtn: false,
      disableSaveBtn: false
    });
    // Skip canvas export to avoid CORS taint issues; we only need coordinates
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "newFile.jpeg"
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = this.state.canvas;
    const pixelRatio = window.devicePixelRatio;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");

    canvas.width = crop.width * pixelRatio * scaleX;
    canvas.height = crop.height * pixelRatio * scaleY;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    return new Promise((resolve) => {
      try {
        canvas.toBlob(
          blob => {
            if (!blob) {
              resolve(null);
              return;
            }
            blob.name = fileName;
            window.URL.revokeObjectURL(this.fileUrl);
            this.fileUrl = window.URL.createObjectURL(blob);
            resolve(this.fileUrl);
          },
          "image/jpeg",
          1
        );
      } catch (e) {
        // Tainted canvas; ignore image export, coordinates are sufficient
        resolve(null);
      }
    });
  }

  plotSpecificCoordinate = (e, key) => {
    this.setState({
      coordinateId: key.id,
      specificCoordinates: key.coordinates,
      regionContainsPlot: true
    });
    // Decide ROI type from key if available
    let savedType = key.roi_type;
    if (!savedType && key.camera_settings && key.camera_settings.roi_type !== undefined) {
      savedType = key.camera_settings.roi_type === true ? 'POLYGON' : 'RECTANGLE';
    }
    const roiType = savedType ? savedType : this.state.roi_type;

    if (key.coordinates) {
      try {
        const cor = Array.isArray(key.coordinates) ? key.coordinates : JSON.parse(key.coordinates);
        if (roiType === 'POLYGON') {
          this.setState({ roi_type: 'POLYGON', coordinates: cor, polygonClosed: true }, () => {
            if (this.polygonCanvasRef.current) this.drawPolygonBase();
          });
        } else {
          const initalPoint = cor[0];
          const secondPoint = cor[1];
          const thirdPoint = cor[2];
          const x = initalPoint[0];
          const y = initalPoint[1];
          const w = Math.abs(secondPoint[0] - initalPoint[0]);
          const h = Math.abs(thirdPoint[1] - secondPoint[1]);
          const crop = { ...(this.state.crop || { unit: 'px' }), x, y, width: w, height: h };
          this.setState({ roi_type: 'RECTANGLE', crop });
        }
      } catch (err) {
        console.warn('Failed to parse coordinates for plotting', err);
      }
    }
  };
  onShowAllPlotPoints = showAllploted => {
    this.setState({
      showAllploted: showAllploted.target.checked
    });
    if (showAllploted.target.checked) {
      this.setState({
        checkboxShowAllROI: showAllploted.target.checked
      });
      let allPlots = this.state.roiCoordinatesObjFromAPI;
      for (let i = 0; i < allPlots.length; i++) {
        let coordinates = allPlots[i].coordinates;

        if (coordinates) {
          const canvas = this.state.canvas;
          let ctx = canvas.getContext("2d");
          // ctx.fillStyle = '#f00';
          ctx.beginPath();
        }
      }
    } else {
      this.getCameraROIById(this.props.cameraParam.id);
      this.setState({
        checkboxShowAllROI: false
      });
    }
  };
  deleteUpdateCoordinate2 = () => {
    this.setState({
      disableSaveBtn: true,
      disableUpdateBtn: true
    });
    this.getCameraROIById(this.props.cameraParam.id);
  };
  onSave = () => {
    let coordinate = this.state.coordinates;
    if (coordinate.length > 0) {
      this.setState({
        blockUI: true
      });
      setTimeout(() => {
        let cameraCor = coordinate;
        let cameraParam = this.props.cameraParam;
        let param = {
          coordinates: JSON.stringify(cameraCor),
          camera_id: cameraParam.id,
          status: false,
          roi_type: this.state.roi_type
        };

        addCameraRoi(param).then(response => {
          if (response && response.isSuccess) {
            this.setState(
              {
                imageHasPlotPoint: true,
                blockUI: false,
                disableSaveBtn: true,
                disableUpdateBtn: true
              },
              () => {
                successToast("Co-ordinates saved ");
              }
            );
          }
        });
      }, 500);
    } else {
      warningToast("Please select region");
    }
  };

  //
  render() {
    return (
      <Fragment>
        <BlockUi tag="div" blocking={this.state.blockUI} color="#147b82">
          {this.state.imageHasPlotPoint && (
            <div>
              {!this.state.checkboxShowAllROI && (
                <>
                  <div className="align-left">
                    {this.state.roiCoordinatesObjFromAPI &&
                      this.state.roiCoordinatesObjFromAPI.map((key, value) => (
                          <CustomizedButtons
                              className={"mr-1 ml-1 "}
                              submit={e => {
                                this.plotSpecificCoordinate(e, key);
                              }}
                              title={"Co-ordinates " + value}
                              id={value + "button"}
                          />
                      ))}
                  </div>
                </>
              )}

              <p className="align-left">
                Show all plotted points{" "}
                <CustomizedSwitch
                    checked={this.state.showAllploted}
                    onChange={this.onShowAllPlotPoints}
                    color={"primary"}
                    className={"cursor-pointer"}
                    name={'showAllploted'}
                />
              </p>
            </div>
          )}

          <div style={{ textAlign: "center" }}>
            <h2>Image Crop</h2>
            <div className="align-left" style={{ marginTop: "10px" }}>
              <CustomizedButtons
                  className={"mr-1 ml-1 "}
                  submit={() => this.setRoiType("RECTANGLE")}
                  title={"RECTANGLE"}
                  color={this.state.roi_type === "RECTANGLE" ? "primary" : "secondary"}
              />
              <CustomizedButtons
                  className={"mr-1 ml-1 "}
                  submit={() => this.setRoiType("POLYGON")}
                  title={"Polygon"}
                  color={this.state.roi_type === "POLYGON" ? "primary" : "secondary"}
              />
            </div>
            <div style={{ marginTop: "20px" }}>
              {this.state.roi_type === "RECTANGLE" && (
                <ReactCrop
                  width={this.state.displayWidth}
                  height={this.state.displayHeight}
                  src={this.state.imagePath}
                  crop={this.state.crop}
                  onChange={crop => {
                    this.handleCrop(crop);
                  }}
                  onImageLoaded={this.onImageLoaded}
                  onComplete={this.onCropComplete}
                />
              )}
              {this.state.roi_type === "POLYGON" && (
                <div style={{ position: "relative", display: "inline-block" }}>
                  <canvas
                    ref={this.setPolygonCanvas}
                    width={640}
                    height={640}
                    onClick={this.handleCanvasClick}
                    style={{ border: "1px solid #ddd", cursor: "crosshair" }}
                  />
                </div>
              )}
            </div>

            <div
              id={"imageId"}
              style={{ marginTop: "20px", textAlign: "center" }}
            >
              {!this.state.imageHasPlotPoint && (
                <>
                  <CustomizedButtons
                      title={"Save"}
                      submit={this.onSave}
                      color={"primary"}
                      flag={this.state.disableSaveBtn}
                      style={{ marginRight: "5px" }}
                  />
                  <CustomizedButtons
                      title={"reset canvas"}
                      submit={this.deleteUpdateCoordinate2}
                      color={"secondary"}
                      style={{ marginRight: "5px" }}
                  />

                  {this.state.roi_type === "POLYGON" && (
                    <>
                      <CustomizedButtons
                        title={"Undo point"}
                        submit={this.undoLastPoint}
                        color={"secondary"}
                        style={{ marginRight: "5px" }}
                      />
                      <CustomizedButtons
                        title={"Clear"}
                        submit={this.clearPolygon}
                        color={"secondary"}
                        style={{ marginRight: "5px" }}
                      />
                    </>
                  )}

                </>
              )}
              {this.state.imageHasPlotPoint && (
                <>
                  <CustomizedButtons
                      title={"Update"}
                      submit={this.cropUpdateImage}
                      color={"primary"}
                      flag={this.state.disableUpdateBtn}
                      style={{ marginRight: "5px" }}
                  />
                  <CustomizedButtons
                      title={"reset canvas"}
                      submit={this.deleteUpdateCoordinate2}
                      color={"secondary"}
                      style={{ marginRight: "5px" }}
                  />

                  {this.state.roi_type === "POLYGON" && (
                    <>
                      <CustomizedButtons
                        title={"Undo point"}
                        submit={this.undoLastPoint}
                        color={"secondary"}
                        style={{ marginRight: "5px" }}
                      />
                      <CustomizedButtons
                        title={"Clear"}
                        submit={this.clearPolygon}
                        color={"secondary"}
                        style={{ marginRight: "5px" }}
                      />
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </BlockUi>
      </Fragment>
    );
  }
}

export default RegionPlot1;
